import { useContext, forwardRef, useEffect, useRef } from 'react'
import { TabsContext } from './tabs-context'
import { makeContentId, makeTriggerId } from '../constants'
import { StyledTabsContent } from '../styled-components'
import PropTypes from 'prop-types'

const TabsContent = forwardRef((props, forwardedRef) => {
  const { value, children, ...contentProps } = props

  const context = useContext(TabsContext)

  const triggerId = makeTriggerId(context.baseId, value)
  const contentId = makeContentId(context.baseId, value)

  const isSelected = value === context.value
  const isMountAnimationPreventedRef = useRef(isSelected)

  useEffect(() => {
    const rAF = requestAnimationFrame(
      () => (isMountAnimationPreventedRef.current = false)
    )
    return () => cancelAnimationFrame(rAF)
  }, [])

  return (
    <>
      {isSelected && (
        <StyledTabsContent
          data-state={isSelected ? 'active' : 'inactive'}
          role="tabpanel"
          aria-labelledby={triggerId}
          hidden={!isSelected}
          id={contentId}
          tabIndex={0}
          {...contentProps}
          ref={forwardedRef}
          style={{
            ...props.style,
            animationDuration: isMountAnimationPreventedRef.current
              ? '0s'
              : undefined
          }}
        >
          {isSelected && children}
        </StyledTabsContent>
      )}
    </>
  )
})

TabsContent.propTypes = {
  value: PropTypes.string
}

TabsContent.displayName = 'TabsContent'
export default TabsContent
